import PropTypes from 'prop-types';
import Table from '../ui/Table';

const ListadoAlumnosActas = (props) => {
  const columns = [
    { Header: 'Seleccionar', accessor: 'actions', sortable: false },
    {
      Header: 'ID',
      accessor: 'ccodcli',
    },
    {
      Header: 'Nombre',
      accessor: 'sNombre',
    },
    {
      Header: 'Apellidos',
      accessor: 'sApellidos',
    },
    {
      Header: 'Documento',
      accessor: 'CDNICIF',
    },
  ];

  return (
    <Table
      columns={columns}
      data={props.data}
      defaultPageSize={10}
      showPaginationBottom
      className="-striped -highlight mt-5 text-center"
    />
  );
};
ListadoAlumnosActas.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
};
export default ListadoAlumnosActas;
